/**
 * ![deepPurple 50](https://mui.com/static/colors-preview/deepPurple-50-24x24.png) ![deepPurple 100](https://mui.com/static/colors-preview/deepPurple-100-24x24.png) ![deepPurple 200](https://mui.com/static/colors-preview/deepPurple-200-24x24.png) ![deepPurple 300](https://mui.com/static/colors-preview/deepPurple-300-24x24.png) ![deepPurple 400](https://mui.com/static/colors-preview/deepPurple-400-24x24.png) ![deepPurple 500](https://mui.com/static/colors-preview/deepPurple-500-24x24.png) ![deepPurple 600](https://mui.com/static/colors-preview/deepPurple-600-24x24.png) ![deepPurple 700](https://mui.com/static/colors-preview/deepPurple-700-24x24.png) ![deepPurple 800](https://mui.com/static/colors-preview/deepPurple-800-24x24.png) ![deepPurple 900](https://mui.com/static/colors-preview/deepPurple-900-24x24.png) ![deepPurple A100](https://mui.com/static/colors-preview/deepPurple-A100-24x24.png) ![deepPurple A200](https://mui.com/static/colors-preview/deepPurple-A200-24x24.png) ![deepPurple A400](https://mui.com/static/colors-preview/deepPurple-A400-24x24.png) ![deepPurple A700](https://mui.com/static/colors-preview/deepPurple-A700-24x24.png)
 */
const deepPurple = {
  /**
   * Preview: ![deepPurple 50](https://mui.com/static/colors-preview/deepPurple-50-24x24.png)
   */
  50: '#ede7f6',
  /**
   * Preview: ![deepPurple 100](https://mui.com/static/colors-preview/deepPurple-100-24x24.png)
   */
  100: '#d1c4e9',
  /**
   * Preview: ![deepPurple 200](https://mui.com/static/colors-preview/deepPurple-200-24x24.png)
   */
  200: '#b39ddb',
  /**
   * Preview: ![deepPurple 300](https://mui.com/static/colors-preview/deepPurple-300-24x24.png)
   */
  300: '#9575cd',
  /**
   * Preview: ![deepPurple 400](https://mui.com/static/colors-preview/deepPurple-400-24x24.png)
   */
  400: '#7e57c2',
  /**
   * Preview: ![deepPurple 500](https://mui.com/static/colors-preview/deepPurple-500-24x24.png)
   */
  500: '#673ab7',
  /**
   * Preview: ![deepPurple 600](https://mui.com/static/colors-preview/deepPurple-600-24x24.png)
   */
  600: '#5e35b1',
  /**
   * Preview: ![deepPurple 700](https://mui.com/static/colors-preview/deepPurple-700-24x24.png)
   */
  700: '#512da8',
  /**
   * Preview: ![deepPurple 800](https://mui.com/static/colors-preview/deepPurple-800-24x24.png)
   */
  800: '#4527a0',
  /**
   * Preview: ![deepPurple 900](https://mui.com/static/colors-preview/deepPurple-900-24x24.png)
   */
  900: '#311b92',
  /**
   * Preview: ![deepPurple A100](https://mui.com/static/colors-preview/deepPurple-A100-24x24.png)
   */
  A100: '#b388ff',
  /**
   * Preview: ![deepPurple A200](https://mui.com/static/colors-preview/deepPurple-A200-24x24.png)
   */
  A200: '#7c4dff',
  /**
   * Preview: ![deepPurple A400](https://mui.com/static/colors-preview/deepPurple-A400-24x24.png)
   */
  A400: '#651fff',
  /**
   * Preview: ![deepPurple A700](https://mui.com/static/colors-preview/deepPurple-A700-24x24.png)
   */
  A700: '#6200ea',
} as const;

export default deepPurple;
